import { rollBarId, environment } from './general.constant';
import { Configuration } from 'rollbar';
import packageJson from '../../../../../package.json';
import { rollbarTransform } from '../../external/rollbar/rollbar-context.util';

export const ROLLBAR_CONFIG: Configuration = {
    accessToken: rollBarId,
    captureUncaught: true,
    captureUnhandledRejections: true,
    maxItems: 10,
    itemsPerMinute: 5,
    transform: rollbarTransform as NonNullable<Configuration['transform']>,
    payload: {
        environment: environment,
        client: {
            javascript: {
                source_map_enabled: true,
                code_version: packageJson.version,
                guess_uncaught_frames: true,
            },
        },
    },
};
